import React from 'react'
import './Banner.css'

const Banner = ({ image }) => {
    return (
        <>
            <section className='vission_banner'>
                <div className='container'>
                    <div className='banner_div'>
                        <img className='banner_img' src={image} alt="gurudev-banner" />
                    </div>
                </div>
            </section>
        </>
    )
}

export default Banner